import { useState, useCallback } from 'react';
import { QueryKey } from 'react-query';

import { ID } from '../../../../../../../types';
import {
  UniversalFilterUsersValue,
  UniversalFilterUsersModes,
  UniversalFilterUsersFilterState,
  UniversalFilterUsersOnFilterStateChange,
  UniversalFilterUsersOnChange
} from '../../UniversalFilterUsers.types';

import { useMountEffect } from '../../../../../../../common/hooks/useMountEffect';
import { useReactQueryState } from '../../../../../../../main/common/reactQuery/hooks/useReactQueryState';

import { useUniversalFilterUsersFilterState } from '../useUniversalFilterUsersFilterState';

import {
  UniversalFilterTemplateModeOption,
  UniversalFilterTemplateOnModeChange
} from '../../../../helpers/UniversalFilterTemplate';

import { filtersKeys } from '../../../../../../../locales/keys';

const defaultMode = UniversalFilterUsersModes.CONTAINS_ANY_OF;

const modeOptions: UniversalFilterTemplateModeOption<UniversalFilterUsersModes>[] =
  [
    {
      value: UniversalFilterUsersModes.CONTAINS_ANY_OF,
      i18nText: filtersKeys.modes.containsAnyOf
    }
    // {
    //   value: UniversalFilterUsersModes.CONTAINS_ALL_OF,
    //   i18nText: filtersKeys.modes.containsAllOf
    // },
    // {
    //   value: UniversalFilterUsersModes.CONTAINS_ONLY,
    //   i18nText: filtersKeys.modes.containsOnly
    // },
    // {
    //   value: UniversalFilterUsersModes.CONTAINS_NONE_OF,
    //   i18nText: filtersKeys.modes.containsNoneOf
    // },
    // {
    //   value: UniversalFilterUsersModes.DOES_NOT_CONTAIN_ANY_OF,
    //   i18nText: filtersKeys.modes.doesNotContainAnyOf
    // }
    // {
    //   value: UniversalFilterUsersModes.IS_EMPTY,
    //   i18nText: filtersKeys.modes.isEmpty
    // },
    // {
    //   value: UniversalFilterUsersModes.IS_NOT_EMPTY,
    //   i18nText: filtersKeys.modes.isNotEmpty
    // }
  ];

interface UniversalFilterUsersOptions {
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterUsersValue;
  onChange: UniversalFilterUsersOnChange;
}

function useUniversalFilterUsers({
  filterStateCacheKey,
  filterValue,
  onChange
}: UniversalFilterUsersOptions) {
  const { value: savedState, setValue: saveState } =
    useReactQueryState<UniversalFilterUsersFilterState>(filterStateCacheKey);

  const { handleApplyFilterState, handleParseFilterValue } =
    useUniversalFilterUsersFilterState({
      onChange
    });

  const [filterState, setFilterState] =
    useState<UniversalFilterUsersFilterState>(
      savedState ||
        handleParseFilterValue(filterValue) || {
          mode: defaultMode,
          userIds: []
        }
    );

  useMountEffect(() => {
    handleApplyFilterState(filterState);
  });

  const handleFilterStateChange =
    useCallback<UniversalFilterUsersOnFilterStateChange>(
      (state) => {
        setFilterState(state);
        handleApplyFilterState(state);
        saveState(state);
      },
      [handleApplyFilterState, saveState]
    );

  const handleModeChange = useCallback<
    UniversalFilterTemplateOnModeChange<UniversalFilterUsersModes>
  >(
    (mode) => {
      handleFilterStateChange({
        mode,
        userIds: filterState.userIds || []
      });
    },
    [filterState, handleFilterStateChange]
  );

  const handleUserIdsChange = useCallback<(userIds: ID[]) => void>(
    (userIds) => {
      handleFilterStateChange({
        mode: filterState.mode,
        userIds: userIds || []
      });
    },
    [filterState, handleFilterStateChange]
  );

  return {
    modeOptions,
    filterState,
    handleModeChange,
    handleUserIdsChange
  };
}

export default useUniversalFilterUsers;
